<template>
  <div class="prescription">
    <b-modal
      id="recepty-cancel-modal"
      :title="$t('visit.prescriptionDetailsTitle')"
      size="md"
      @hide="$emit('close')"
    >
      <div class="">
        <b>{{ $t('visit.removePrescriptionConfirmation') }}</b> <br />
        {{ $t('visit.removePrescriptionInfo') }}
      </div>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('recepty-cancel-modal')"
          class="btn-sm m-1"
          >{{ $t('close') }}</b-button
        >
        <b-button
          @click="handleCancelConfirmed(receptyData.id)"
          :disabled="loading ? '' : disabled"
          class="btn btn-danger btn-sm m-1"
          >{{ $t('visit.removePrescriptionSubmit') }}</b-button
        >
      </template>
    </b-modal>
    <b-modal
      id="recepty-info-modal"
      :title="receptyData.title"
      dialog-class="prescription-preview-dialog"
      @hide="$emit('close')"
    >
      <center>
        <b-spinner label="Spinning" v-if="loaded == false"></b-spinner>
      </center>
      <div class="prescription-preview-frame">
        <iframe
          id="frP1"
          v-if="loaded"
          :src="iframe.srcdoc"
          type="application/pdf"
          frameborder="0"
        ></iframe>
      </div>
      <template #modal-footer>
        <b-button variant="primary" :disabled="!!pdfLoadingRequests[receptyData.id]"
          @click="handleDownloadPdf(receptyData.id)">
          <b-spinner small v-if="pdfLoadingRequests[receptyData.id]" />
          <span v-else>{{ $t('visit.downloadPdfBtn') }}</span>
        </b-button>
        <b-button variant="secondary" :disabled="!!pdfLoadingRequests[receptyData.id]"
          @click="handlePrintPdf(receptyData.id)">
          <b-spinner small v-if="pdfLoadingRequests[receptyData.id]" />
          <span v-else>{{ $t('visit.printBtn') }}</span>
        </b-button>
        <b-button @click="$bvModal.hide('recepty-info-modal')">{{
          $t('close')
        }}</b-button>
      </template>
    </b-modal>
    <div v-for="el in prescriptions" :key="`prescription-${el.id}`">
      <div style="margin-top: 5px; margin-right: 6px">
        <b-button
          v-if="el.cancel_date == null"
          variant="danger"
          @click="handleCancel(el.id)"
          class="mr-1 float-right"
        >
          <font-awesome-icon icon="file-prescription" />
        </b-button>
        <b-button
          variant="primary"
          :disabled="!!htmlLoadingRequests[el.id]"
          @click="handleViewDetails(el.id)"
          class="mr-1 float-right"
        >
          <b-spinner small v-if="htmlLoadingRequests[el.id]" />
          <font-awesome-icon v-else icon="file-prescription" />
        </b-button>
        <b-button
          v-if="el.cancel_date == null"
          variant="outline-secondary"
          :disabled="statusP1[el.id] === null"
          @click="handleStatusP1(el.id)"
          class="mr-1 float-right"
          title="Sprawdź w P1, czy recepta została zrealizowana"
        >
          <b-spinner small v-if="statusP1[el.id] === null" />
          <span v-else>Status w P1</span>
        </b-button>
        <b-button @click="handleCopyPrescription(el.id)">{{ $t('visit.copyPrescription') }}</b-button>
        <div v-if="statusP1[el.id]" class="ml-2 mt-2 small" style="clear: both">
          <b>Status w P1:</b> {{ statusP1[el.id] }}
        </div>
        <span v-if="el.cancel_date != null" class="ml-2 mt-3 float-left"
          ><i
            ><b>{{ $t('visit.removed') }}: </b> :
            {{ new Date(el.cancel_date * 1000).toLocaleString('pl-PL') }}</i
          ></span
        >
      </div>
      <div style="clear: both; margin: 0px"></div>
      <Single
        v-if="el.cancel_date != null"
        style="
          background: #eee;
          border: 1px dashed;
          border-style: dashed;
          border-color: #dc3545;
          color: #dc3545;
          margin-top: 4px;
        "
        :data="el"
        category="prescription"
        :class="`visit-${el.visitId}`"
      />
      <Single
        v-else
        :data="el"
        category="prescription"
        :class="`visit-${el.visitId}`"
      />
    </div>
  </div>
</template>
<script>
import prescriptionApi from '../../../../services/prescriptionApi'
import Single from './Single'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      loaded: false,
      loading: false,
      receptyData: {
        title: ''
      },
      iframe: {
        style: null,
        wrapperStyle: null,
        srcdoc: null
      },
      pdfBlobCache: {},
      pdfLoadingRequests: {},
      htmlBlobCache: {},
      htmlLoadingRequests: {},
      statusP1: {} // id -> null (w trakcie) | opis
    }
  },
  components: {
    Single
  },
  computed: {
    ...mapState('Patient', {
      prescriptions: (state) => state.prescriptions
    })
  },
  methods: {
    async handleDownload(prescriptionId) {
      // let response = await prescriptionApi.downloadPrescription(prescriptionId)
      //
      // let blob = new Blob([response.data], { type: 'application/pdf' })
      // this.iframe.srcdoc=window.URL.createObjectURL(blob)
      // let link = document.createElement('a')
      // link.href = window.URL.createObjectURL(blob)
      // link.download = `prescription_${prescriptionId}.pdf`
      // link.click()
      // link.remove()
    },
    async handleCancelConfirmed(prescriptionId) {
      try {
        this.loading = true
        this.receptyData.btnCaption = 'Usuń...'
        await prescriptionApi.cancelPrescription(prescriptionId)
        this.loading = false
        // alert('Recepta skutecznie usunięta')
        this.$bvModal.hide('recepty-cancel-modal')
        this.$swal(this.$t('success'), 'Recepta skutecznie usunięta', 'success')
      } catch (ex) {
        this.$bvModal.hide('recepty-cancel-modal')
        const dane = ex?.response?.data
        this.$swal(
          this.$t('error'),
          ['RECEPTA_ODRZUCONA_P1', 'RECEPTA_NIE_DO_ANULOWANIA'].includes(dane?.code) ? dane.message : 'Nie udało się usunąć recepty',
          'error'
        )
      }
    },
    async handleStatusP1(prescriptionId) {
      this.$set(this.statusP1, prescriptionId, null)
      try {
        const dane = await prescriptionApi.statusPrescription(prescriptionId)
        this.$set(this.statusP1, prescriptionId, dane.opis || 'brak danych z P1')
      } catch (ex) {
        this.$set(this.statusP1, prescriptionId, 'nie udało się odczytać statusu z P1')
      }
    },
    async handleCancel(prescriptionId) {
      this.loading = false
      this.$bvModal.show('recepty-cancel-modal')
      this.receptyData = {
        id: prescriptionId
      }
    },
    // Generic fetch-and-cache with retry/backoff, shared by the PDF and HTML
    // asset fetchers below. The cloud file can legitimately still be
    // generating on the first click, so a lone request can time out -
    // retrying here means the user never has to click again, and once
    // cached, re-requesting the same prescription resolves instantly. Only
    // one fetch per prescriptionId/asset is ever in flight; callers share it.
    prefetchAsset(cacheMap, loadingMap, prescriptionId, fetchFn, attemptsLeft, delayMs) {
      if (cacheMap[prescriptionId] || loadingMap[prescriptionId]) {
        return loadingMap[prescriptionId] || Promise.resolve(cacheMap[prescriptionId])
      }

      const attempt = async (remaining, wait) => {
        try {
          return await fetchFn()
        } catch (e) {
          if (remaining <= 1) throw e
          await new Promise((resolve) => setTimeout(resolve, wait))
          return attempt(remaining - 1, wait * 2)
        }
      }

      const promise = attempt(attemptsLeft, delayMs)
      this.$set(loadingMap, prescriptionId, promise)

      promise
        .then((result) => this.$set(cacheMap, prescriptionId, result))
        .catch(() => {})
        .finally(() => this.$delete(loadingMap, prescriptionId))

      return promise
    },
    prefetchPrescriptionPdf(prescriptionId) {
      return this.prefetchAsset(this.pdfBlobCache, this.pdfLoadingRequests, prescriptionId, async () => {
        const response = await prescriptionApi.downloadPrescription(prescriptionId)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      }, 5, 2000)
    },
    // .html uploads to cloud storage well before the .pdf finishes
    // rendering, so this converges much faster - used for the instant
    // preview, while the PDF is only fetched lazily via "Download PDF".
    prefetchPrescriptionHtml(prescriptionId) {
      return this.prefetchAsset(this.htmlBlobCache, this.htmlLoadingRequests, prescriptionId, async () => {
        const response = await prescriptionApi.downloadPrescriptionHtml(prescriptionId)
        const blob = new Blob([response.data], { type: 'text/html' })
        return window.URL.createObjectURL(blob)
      }, 4, 1500)
    },
    showPrescriptionPreview(blobUrl) {
      this.iframe.srcdoc = blobUrl
      this.iframe.wrapperStyle = {
        overflow: 'hidden',
        height: '100%'
      }
      this.loaded = true
    },
    async handleViewDetails(prescriptionId) {
      this.$bvModal.show('recepty-info-modal')
      this.receptyData = {
        id: prescriptionId,
        title: 'Prescription Details - ' + prescriptionId
      }
      this.iframe.style = {
        position: 'absolute',
        width: '90%',
        height: '100%'
      }

      if (this.htmlBlobCache[prescriptionId]) {
        this.showPrescriptionPreview(this.htmlBlobCache[prescriptionId])
        return
      }

      this.iframe.srcdoc = null
      this.loaded = false
      try {
        const blobUrl = await this.prefetchPrescriptionHtml(prescriptionId)
        this.showPrescriptionPreview(blobUrl)
      } catch (e) {
        this.$bvModal.hide('recepty-info-modal')
        this.$swal(this.$t('error'), 'Nie udało się pobrać recepty', 'error')
      }
    },
    async handleDownloadPdf(prescriptionId) {
      try {
        const blobUrl = await this.prefetchPrescriptionPdf(prescriptionId)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `prescription_${prescriptionId}.pdf`
        link.click()
      } catch (e) {
        this.$swal(this.$t('error'), 'Nie udało się pobrać pliku PDF', 'error')
      }
    },
    async handlePrintPdf(prescriptionId) {
      try {
        const blobUrl = await this.prefetchPrescriptionPdf(prescriptionId)
        let printFrame = document.getElementById('pdf-print-frame')
        if (!printFrame) {
          printFrame = document.createElement('iframe')
          printFrame.id = 'pdf-print-frame'
          printFrame.style.display = 'none'
          document.body.appendChild(printFrame)
        }
        printFrame.onload = () => {
          printFrame.contentWindow.focus()
          printFrame.contentWindow.print()
        }
        printFrame.src = blobUrl
      } catch (e) {
        this.$swal(this.$t('error'), 'Nie udało się wydrukować recepty', 'error')
      }
    },
    handleCopyPrescription(id) {
      this.$emit('copy', id)
    }
  }
}
</script>
<style>
.prescription-preview-dialog {
  max-width: 420px;
}

.prescription-preview-frame {
  width: 100%;
  height: 75vh;
}

.prescription-preview-frame iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
